import type { ModuleRoute } from '../module-contract'
import type { AccessContext } from './access'
import { routeOpensFor } from './nav-visibility'

/**
 * The header's two ways into a working surface - §9.162's navigation: the driving app and the kitchen board.
 *
 * **Each asks the guard of the route it opens - FRONTEND.md §9.759, FB-1078.** They asked `surfacesFor(role)`,
 * which offered *Rozvoz* to every administrator while `/driving` refused them and offered nothing to a cook or
 * waiter marked *Jazdí aj rozvoz* - the third place deciding who sees these screens, beside the sidebar and the
 * router, and the only one nothing held to the others (`agos-nav.test.ts` holds those two). Read by path through
 * `routeOpensFor`, so no guard is restated here. `surfacesFor` keeps its own job: where a sign-in lands.
 *
 * **`/kitchen` carries no guard** (FB-002, the board is open to every signed-in employee on purpose), so
 * *Nástenka* is offered to everybody the router admits there - which is everybody.
 */
export const HEADER_SURFACES = [
  { surface: 'driving', path: '/driving' },
  { surface: 'board', path: '/kitchen' },
] as const

export type HeaderSurface = (typeof HEADER_SURFACES)[number]

/** The header links this person is offered, in the header's order. */
export function headerSurfacesFor(
  routes: readonly Pick<ModuleRoute, 'path' | 'guard'>[],
  access: AccessContext,
): HeaderSurface[] {
  return HEADER_SURFACES.filter((option) => routeOpensFor(option.path, routes, access))
}
